import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38308ae8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "srh__department-toggle flex h-[3.5714285rem] font-medium text-gray-70" }

import { isClassicSite } from "@ocm/services/ocm-object";
import ToggleItem from "@/components/ToggleItem.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DepartmentToggle',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (!_unref(isClassicSite))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(ToggleItem, { "department-type": "damen" }, {
            default: _withCtx(() => [
              _createTextVNode("Damen")
            ]),
            _: 1
          }),
          _createVNode(ToggleItem, { "department-type": "herren" }, {
            default: _withCtx(() => [
              _createTextVNode("Herren")
            ]),
            _: 1
          }),
          _createVNode(ToggleItem, { "department-type": "kinder" }, {
            default: _withCtx(() => [
              _createTextVNode("Kinder")
            ]),
            _: 1
          })
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})